import axiosInstance from './axiosInstance';

const authApi = {
  login: (email, password) =>
    axiosInstance.post('/users/login', { email, password }).then(r => r.data),

  register: (data) =>
    axiosInstance.post('/users/register', data).then(r => r.data),

  logout: () => {
    localStorage.removeItem('accessToken');
  }
};

export default authApi;
